module.exports = {
      id: "parking-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.a0c47b73.svg#parking-usage",
      toString: function () {
        return this.url;
      }
    }